import { render } from "./ErrorSorry.vue?vue&type=template&id=208c7792"
import script from "./ErrorSorry.vue?vue&type=script&lang=js"
export * from "./ErrorSorry.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__